// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/tag_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_client } from "../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../google/api/resource_pb";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/tag_service.proto.
 */
export const file_api_v1_tag_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * Tag represents a user-defined tag
 *
 * @generated from message journal.api.v1.Tag
 */
export type Tag = Message<"journal.api.v1.Tag"> & {
  /**
   * The resource name of the tag.
   * Format: tags/{tag_id}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The unique identifier of tag (UUID).
   *
   * @generated from field: string tag_id = 8;
   */
  tagId: string;

  /**
   * The display name of the tag (1-50 characters)
   * This is the actual tag name shown to users
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * The color token for the tag
   *
   * @generated from field: string color_token = 3;
   */
  colorToken: string;

  /**
   * The resource name of the creator.
   * Format: users/{user}
   *
   * @generated from field: string creator = 4;
   */
  creator: string;

  /**
   * Output only. The creation timestamp.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: Timestamp;

  /**
   * Output only. The last update timestamp.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 6;
   */
  updateTime?: Timestamp;

  /**
   * Output only. The number of memos associated with this tag.
   *
   * @generated from field: int32 usage_count = 7;
   */
  usageCount: number;
};

/**
 * Describes the message journal.api.v1.Tag.
 * Use `create(TagSchema)` to create a new message.
 */
export const TagSchema: GenMessage<Tag> = /*@__PURE__*/
  messageDesc(file_api_v1_tag_service, 0);

/**
 * ListTagsRequest is the request message for ListTags
 *
 * @generated from message journal.api.v1.ListTagsRequest
 */
export type ListTagsRequest = Message<"journal.api.v1.ListTagsRequest"> & {
  /**
   * Optional. The maximum number of tags to return.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Optional. A page token, received from a previous `ListTags` call.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.ListTagsRequest.
 * Use `create(ListTagsRequestSchema)` to create a new message.
 */
export const ListTagsRequestSchema: GenMessage<ListTagsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_tag_service, 1);

/**
 * ListTagsResponse is the response message for ListTags
 *
 * @generated from message journal.api.v1.ListTagsResponse
 */
export type ListTagsResponse = Message<"journal.api.v1.ListTagsResponse"> & {
  /**
   * The list of tags
   *
   * @generated from field: repeated journal.api.v1.Tag tags = 1;
   */
  tags: Tag[];

  /**
   * A token that can be sent as `page_token` to retrieve the next page.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message journal.api.v1.ListTagsResponse.
 * Use `create(ListTagsResponseSchema)` to create a new message.
 */
export const ListTagsResponseSchema: GenMessage<ListTagsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_tag_service, 2);

/**
 * CreateTagRequest is the request message for CreateTag
 *
 * @generated from message journal.api.v1.CreateTagRequest
 */
export type CreateTagRequest = Message<"journal.api.v1.CreateTagRequest"> & {
  /**
   * Required. The tag to create.
   *
   * @generated from field: journal.api.v1.Tag tag = 1;
   */
  tag?: Tag;

  /**
   * Optional. The tag ID to use for this tag.
   *
   * @generated from field: string tag_id = 2;
   */
  tagId: string;
};

/**
 * Describes the message journal.api.v1.CreateTagRequest.
 * Use `create(CreateTagRequestSchema)` to create a new message.
 */
export const CreateTagRequestSchema: GenMessage<CreateTagRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_tag_service, 3);

/**
 * UpdateTagRequest is the request message for UpdateTag
 *
 * @generated from message journal.api.v1.UpdateTagRequest
 */
export type UpdateTagRequest = Message<"journal.api.v1.UpdateTagRequest"> & {
  /**
   * Required. The tag to update.
   * The `name` field is required.
   *
   * @generated from field: journal.api.v1.Tag tag = 1;
   */
  tag?: Tag;

  /**
   * Required. The list of fields to update.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateTagRequest.
 * Use `create(UpdateTagRequestSchema)` to create a new message.
 */
export const UpdateTagRequestSchema: GenMessage<UpdateTagRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_tag_service, 4);

/**
 * DeleteTagRequest is the request message for DeleteTag
 *
 * @generated from message journal.api.v1.DeleteTagRequest
 */
export type DeleteTagRequest = Message<"journal.api.v1.DeleteTagRequest"> & {
  /**
   * Required. The resource name of the tag to delete.
   * Format: tags/{tag}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeleteTagRequest.
 * Use `create(DeleteTagRequestSchema)` to create a new message.
 */
export const DeleteTagRequestSchema: GenMessage<DeleteTagRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_tag_service, 5);

/**
 * FindOrCreateTagRequest is the request message for FindOrCreateTag
 *
 * @generated from message journal.api.v1.FindOrCreateTagRequest
 */
export type FindOrCreateTagRequest = Message<"journal.api.v1.FindOrCreateTagRequest"> & {
  /**
   * Required. The display name of the tag to find or create.
   *
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * Optional. The color token for the tag (only used when creating a new tag).
   *
   * @generated from field: string color_token = 2;
   */
  colorToken: string;
};

/**
 * Describes the message journal.api.v1.FindOrCreateTagRequest.
 * Use `create(FindOrCreateTagRequestSchema)` to create a new message.
 */
export const FindOrCreateTagRequestSchema: GenMessage<FindOrCreateTagRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_tag_service, 6);

/**
 * TagService provides tag management functionality
 *
 * @generated from service journal.api.v1.TagService
 */
export const TagService: GenService<{
  /**
   * ListTags lists all tags for the current user
   *
   * @generated from rpc journal.api.v1.TagService.ListTags
   */
  listTags: {
    methodKind: "unary";
    input: typeof ListTagsRequestSchema;
    output: typeof ListTagsResponseSchema;
  },
  /**
   * CreateTag creates a new tag
   *
   * @generated from rpc journal.api.v1.TagService.CreateTag
   */
  createTag: {
    methodKind: "unary";
    input: typeof CreateTagRequestSchema;
    output: typeof TagSchema;
  },
  /**
   * UpdateTag updates an existing tag
   *
   * @generated from rpc journal.api.v1.TagService.UpdateTag
   */
  updateTag: {
    methodKind: "unary";
    input: typeof UpdateTagRequestSchema;
    output: typeof TagSchema;
  },
  /**
   * DeleteTag deletes a tag (soft delete)
   *
   * @generated from rpc journal.api.v1.TagService.DeleteTag
   */
  deleteTag: {
    methodKind: "unary";
    input: typeof DeleteTagRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * FindOrCreateTag finds an existing tag by display name for the user, or creates a new one
   *
   * @generated from rpc journal.api.v1.TagService.FindOrCreateTag
   */
  findOrCreateTag: {
    methodKind: "unary";
    input: typeof FindOrCreateTagRequestSchema;
    output: typeof TagSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_tag_service, 0);

